import { EditSharp, RemoveRedEye } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Stack,
  styled,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
  getPromoCodeApi,
  insertPromoCodeApi,
  updatePromoCodeApi,
  updatePromoCodeStatusApi
} from "src/api/commonapi";
import Label from "src/components/Label";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import CustomLoader from "src/components/CustomLoader";
import { YesNoSwitch } from "src/components/YesNoSwitch";

export default function Promocode() {
  const navigate = useNavigate();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [addEditModal, setAddEditModal] = useState(false);
  const [confirmApproveModal, setConfirmApproveModal] = useState(false);
  const [promoCodeList, setPromoCodeList] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [promoCodeData, setPromoCodeData] = useState({
    p_code: "",
    flat_amount: "",
    description: "",
    p_title: "",
    start_date: null,
    end_date: null,
    eligibile_for_welcome_kit: 0
  });

  const resetFormData = () => {
    setPromoCodeData({
      p_code: "",
      flat_amount: "",
      description: "",
      p_title: "",
      start_date: null,
      end_date: null,
      eligibile_for_welcome_kit: 0
    });
    setModalType("Add");
  };

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  useEffect(() => {
    handleGetPromoCodeData();
  }, []);

  const handleSubmit = async () => {
    if (promoCodeData.p_code !== "" && promoCodeData.flat_amount !== "") {
      if (modalType === "Add") {
        setLoading(true);
        const resp = await insertPromoCodeApi({
          ...promoCodeData
        });
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          toggleAddEditModal();
          handleGetPromoCodeData();
        }
        setLoading(false);
      } else {
        setLoading(true);
        const resp = await updatePromoCodeApi({
          ...promoCodeData
        });
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          toggleAddEditModal();
          handleGetPromoCodeData();
        }
        setLoading(false);
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  const handleGetPromoCodeData = async () => {
    setLoading(true);
    const resp = await getPromoCodeApi();
    setLoading(false);
    if (resp.status == 1) {
      setPromoCodeList(resp.data);
    }
  };

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "100px"
    },
    {
      name: "Promo Code Title",
      wrap: true,
      width: "200px",
      selector: (row) => (row.p_title != null && row.p_title != "" ? row.p_title : "-"),
      sortable: true
    },
    {
      name: "Promo Code",
      wrap: true,
      width: "200px",
      selector: (row) => (row.p_code != null && row.p_code != "" ? row.p_code : "-"),
      sortable: true
    },
    {
      name: "Flat Amount",
      wrap: true,
      width: "200px",
      selector: (row) => (row.flat_amount != null && row.flat_amount != "" ? row.flat_amount : "-"),
      sortable: true
    },
    {
      name: "Start Date",
      wrap: true,
      width: "200px",
      selector: (row) => (row.start_date != null && row.start_date != "" ? row.start_date : "-"),
      sortable: true
    },
    {
      name: "End Date",
      wrap: true,
      width: "200px",
      selector: (row) => (row.end_date != null && row.end_date != "" ? row.end_date : "-"),
      sortable: true
    },
    {
      name: "Include Welcome Kit",
      wrap: true,
      width: "200px",
      selector: (row) => (row.eligibile_for_welcome_kit == 1 ? "On" : "Off"),
      sortable: true
    },
    {
      name: "Status",
      width: "150px",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "5px auto"
          }}
        >
          <Label variant={"ghost"} color={row.status === 1 ? "success" : "error"}>
            {row.status === 1 ? "Active" : "De-Active"}
          </Label>
          {loginUser?.u_type != 2 && (
            <Button
              className="bnt-btn-success"
              style={{
                padding: "2px 10px",
                marginTop: "5px",
                color: "white",
                backgroundColor: row.status !== 1 ? "#229A16" : undefined
              }}
              color={row.status === 1 ? "error" : "success"}
              variant="contained"
              onClick={(e) => {
                setRowData(row);
                setConfirmApproveModal(true);
              }}
            >
              {row.status === 1 ? "De-Active" : " Active"}
            </Button>
          )}
        </div>
      )
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => {
              setModalType("Edit");
              setRowData(row);
              setPromoCodeData({
                p_title: row.p_title,
                p_code: row?.p_code,
                flat_amount: row?.flat_amount,
                description: row?.description,
                p_code_id: row.p_code_id,
                start_date: row.start_date,
                end_date: row.end_date,
                eligibile_for_welcome_kit: row.eligibile_for_welcome_kit
              });
              toggleAddEditModal();
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>

          <Tooltip title="View Member List">
            <IconButton
              onClick={() => {
                navigate("/lvb-promocode-member-list", { state: row });
              }}
            >
              <RemoveRedEye color="light" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        <p>
          <b>Description</b> : {data?.description}
        </p>
      </div>
    );
  };

  return (
    <Page title="LVB Promotion Reject Reasons | Local Vocal Business Group">
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Promo Code
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => (toggleAddEditModal(), resetFormData())}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
              disabled={loading}
            >
              Add Promo Code
            </Button>
          </Grid>
        </Grid>

        <Modal
          open={addEditModal}
          onClose={() => (toggleAddEditModal(), resetFormData())}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "5px", textAlign: "center" }}
            >
              {modalType} Promo Code
            </Typography>
            <hr />
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <Grid container>
                <Grid item sm={12} xs={12}>
                  <TextField
                    style={{ marginTop: "15px" }}
                    height={10}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Promo Code Title"
                    name="p_title"
                    size="small"
                    placeholder="Enter Promo Code Title"
                    onChange={(e) => {
                      setPromoCodeData({
                        ...promoCodeData,
                        p_title: e.target.value
                      });
                    }}
                    value={promoCodeData?.p_title}
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    style={{ marginTop: "15px" }}
                    height={10}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Code"
                    name="p_code"
                    size="small"
                    placeholder="Enter Code"
                    onChange={(e) => {
                      setPromoCodeData({
                        ...promoCodeData,
                        p_code: e.target.value
                      });
                    }}
                    value={promoCodeData?.p_code}
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    style={{ marginTop: "15px" }}
                    height={10}
                    fullWidth
                    autoComplete="off"
                    size="small"
                    type="number"
                    label="Flat Amount"
                    name="flat_amount"
                    placeholder="Enter Flat Amount"
                    onChange={(e) => {
                      setPromoCodeData({
                        ...promoCodeData,
                        flat_amount: e.target.value
                      });
                    }}
                    value={promoCodeData?.flat_amount}
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <Stack spacing={3} style={{ marginTop: "15px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="start_date"
                        label="Start Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          promoCodeData.start_date != null
                            ? new Date(promoCodeData.start_date.split("-").reverse().join("-"))
                            : null
                        }
                        minDate={new Date()}
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();

                            const formattedNewStart = `${day}-${month}-${year}`;

                            let updatedForm = {
                              ...promoCodeData,
                              start_date: formattedNewStart
                            };

                            // Check end date
                            if (
                              promoCodeData.end_date &&
                              new Date(promoCodeData.end_date.split("-").reverse().join("-")) <
                                new Date(formattedNewStart.split("-").reverse().join("-"))
                            ) {
                              updatedForm.end_date = "";

                              const notify = notification({
                                type: "error",
                                message: "End date cannot be less than start date."
                              });
                              notify();
                            }

                            setPromoCodeData(updatedForm);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} disabled onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>

                <Grid item sm={12} xs={12}>
                  <Stack spacing={3} style={{ marginTop: "15px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="end_date"
                        label="End Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          promoCodeData.end_date != null
                            ? new Date(promoCodeData.end_date.split("-").reverse().join("-"))
                            : null
                        }
                        minDate={
                          promoCodeData.start_date
                            ? new Date(promoCodeData.start_date.split("-").reverse().join("-"))
                            : new Date()
                        }
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();

                            setPromoCodeData({
                              ...promoCodeData,
                              end_date: `${day}-${month}-${year}`
                            });
                          }
                        }}
                        slotProps={{
                          popper: {
                            placement: "top-start",
                            modifiers: [
                              {
                                name: "flip",
                                enabled: false
                              }
                            ]
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>

                <Grid item sm={12} xs={12}>
                  <TextField
                    style={{ marginTop: "15px" }}
                    height={10}
                    fullWidth
                    autoComplete="off"
                    size="small"
                    type="textarea"
                    multiline
                    rows={3}
                    label="Description"
                    name="description"
                    placeholder="Enter Description"
                    onChange={(e) => {
                      setPromoCodeData({
                        ...promoCodeData,
                        description: e.target.value
                      });
                    }}
                    value={promoCodeData?.description}
                  />
                </Grid>
                <Grid item sm={12} xs={12} sx={{ marginTop: "15px" }}>
                  <FormControl component="fieldset">
                    <FormGroup>
                      <FormControlLabel
                        sx={{
                          gap: 1,
                          marginLeft: 0
                        }}
                        control={
                          <YesNoSwitch
                            name="eligibile_for_welcome_kit"
                            checked={Number(promoCodeData?.eligibile_for_welcome_kit) === 1}
                            onChange={(e) => {
                              const val = e.target.checked ? 1 : 0;
                              setPromoCodeData({
                                ...promoCodeData,
                                eligibile_for_welcome_kit: val
                              });
                            }}
                            disabled={modalType == "Edit"}
                          />
                        }
                        label=" Include Welcome Kit"
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => (toggleAddEditModal(), resetFormData())}
                    style={{ marginTop: "15px", marginRight: "15px" }}
                  >
                    Close
                  </Button>
                  <Button
                    disabled={loading}
                    variant="contained"
                    style={{ marginTop: "15px" }}
                    onClick={() => handleSubmit()}
                    startIcon={loading && <CircularProgress size={20} color="inherit" />}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Modal>
        <Card className="p-2" style={{ padding: "15px" }}>
          <DataTable
            filter
            pagination
            highlightOnHover
            columns={columns}
            data={promoCodeList != null && promoCodeList}
            expandableRows
            expandableRowsComponent={ExpandableRow}
            progressPending={loading}
            progressComponent={<CustomLoader />}
          />
        </Card>
      </Container>

      <Modal open={confirmApproveModal} onClose={() => setConfirmApproveModal(false)}>
        <Box sx={style}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to {rowData?.status === 1 ? "De-Active" : "Active"} this Promo
            Code?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              className="btn btn-primary"
              onClick={async () => {
                const res = await updatePromoCodeStatusApi({
                  p_code_id: rowData?.p_code_id,
                  status: rowData.status === 1 ? 0 : 1
                }); // 1 = Active 0 - De-Active
                if (res.status == 1) {
                  let notify = notification({
                    type: res.status == 0 ? "error" : "success",
                    message: res.message
                  });
                  notify();
                  handleGetPromoCodeData(); // refresh data
                }
                setConfirmApproveModal(false);
              }}
            >
              Yes, {rowData?.status === 1 ? "De-Active" : "Active"}
            </Button>
            <Button variant="outlined" onClick={() => setConfirmApproveModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Page>
  );
}
